import { createFileRoute } from '@tanstack/react-router'
import { OtpReportPage } from '@/features/reports/otps'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/reports/otps')({
  component: () => (
    <RequirePermission permission='report.otp.view'>
      <OtpReportPage />
    </RequirePermission>
  ),
})
